var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 16 } }, [
        _c(
          "h1",
          { staticClass: "logo" },
          [
            _c("i", {
              staticClass: "text-contrast raw-icon el-icon-fa-bars",
              staticStyle: { cursor: "pointer", "margin-right": "35px" },
              on: { click: _vm.toggleMenu }
            }),
            _vm._v(" "),
            !_vm.isMobile
              ? _c("router-link", { attrs: { to: "/" } }, [_vm._v("ITE DV7 ")])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isMobile
        ? _c("el-col", { staticClass: "text-right", attrs: { span: 8 } }, [
            _c(
              "a",
              {
                staticClass: "signout-link",
                attrs: { href: "javascript:" },
                on: { click: _vm.signout }
              },
              [
                _c("i", {
                  staticClass: "el-icon-fa-sign-out",
                  attrs: { title: "Sign out" }
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-col",
        { staticClass: "text-right", attrs: { span: 2 } },
        [_c("lang-select", { staticClass: "set-language" })],
        1
      ),
      _vm._v(" "),
      !_vm.isMobile
        ? _c(
            "el-col",
            { staticClass: "text-right", attrs: { span: 6 } },
            [
              _c(
                "el-dropdown",
                { on: { command: _vm.handleDropdownCommand } },
                [
                  _c("span", { staticClass: "el-dropdown-link" }, [
                    _vm._v("\n       " + _vm._s(_vm.email) + "\n        "),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right"
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "goToActivity" } },
                        [
                          _c("i", { staticClass: "el-icon-fa-eye" }),
                          _vm._v(" Activity Log\n        ")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "signout" } },
                        [
                          _c("i", { staticClass: "el-icon-fa-sign-out" }),
                          _vm._v(" Sign out\n        ")
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-825d0c1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-825d0c1c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/shared/layout/header.vue
// module id = null
// module chunks = 